import { OrderPayload, VideoOrderForm } from '../store/modules/orders/types';
import { Order, VideoOrderFormOptions, VideoOrderPayloadOptions } from '../types/items';

export const getDurationFromDurationKey = (durationKey : number, additionalMin = 1): number => {
  switch (durationKey) {
    case 0:
      return 1;
    case 1:
      return 3;
    case 2:
      return 5;
    default:
      return 5 + +additionalMin;
  }
};

export const getDurationKeyFromDuration = (duration?: number): number => {
  switch (duration) {
    case 1:
      return 0;
    case 3:
      return 1;
    case 5:
      return 2;
    default:
      return 3;
  }
};

export const transformOrderToVideoOrderForm = (order: Order): VideoOrderForm => {

  const videoDuration = order?.options?.video_duration || 3;
  const videoDurationKey = getDurationKeyFromDuration(videoDuration);
  const additionalMin = videoDuration > 5 ? videoDuration - 5 : 6;

  const newOptions: VideoOrderFormOptions = {
    closed_captions: order?.options?.closed_captions || '',
    format: {
      standard: order.options.format.standard,
      square: order.options.format.square,
      portrait: order.options.format.portrait,
    },
    order_title: order.options.order_title,
    scene_title: order.options.scene_title,
    total_price: order.options.total_price,

    // durationOptions
    video_duration_key: videoDurationKey,
    additional_min: additionalMin,
  };

  return {
    ...order,
    id: order.id,
    title: order.title || order.options.order_title || order.options.scene_title,
    scene_id: order.scene_id,
    options: newOptions,
    project_id: order.project_id,
    user_id: order.user_id,
    video_id: order.video_id,
    organization_id: order.organization_id,
    assigned_to_id: order.assigned_to_id,
    first_edit_delivery_id: order.first_edit_delivery_id,
  };
};

export const transformVideoEditFormToOrderPayload = (orderForm: VideoOrderForm): OrderPayload => {
  const durationKey = orderForm.options.video_duration_key;
  const additionalMinutes = orderForm?.options.additional_min;
  const videoDuration = getDurationFromDurationKey(durationKey, additionalMinutes);

  const newOptions: VideoOrderPayloadOptions = {
    closed_captions: orderForm.options.closed_captions,
    format: {
      standard: orderForm.options.format.standard,
      square: orderForm.options.format.square,
      portrait: orderForm.options.format.portrait,
    },
    order_title: orderForm.options.order_title,
    scene_title: orderForm.options.scene_title,
    total_price: orderForm.options.total_price,

    video_duration: videoDuration,
  };

  return {
    id: orderForm.id,
    title: orderForm.title || orderForm.options.order_title || orderForm.options.scene_title,
    scene_id: orderForm.scene_id,
    options: newOptions,
    project_id: orderForm.project_id,
    user_id: orderForm.user_id,
    video_id: orderForm.video_id,
    organization_id: orderForm.organization_id,
    assigned_to_id: orderForm.assigned_to_id,
    first_edit_delivery_id: orderForm.first_edit_delivery_id,
    status_id: orderForm.status_id,
    type_id: orderForm.type_id,
  };
};
